import React from 'react';
import { ComposedChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer, Label } from 'recharts';
import styles from "./verticalBarGraph.module.css";

const LineGraphOR = ({ data }) => {

    // const transformedData = Object.entries(data[0]?.data || {}).map(([week, value]) => ({
    //     weekLabel: week,
    //     weeklyOr: parseFloat(value) || 0,
    //     agileOr: parseFloat(data[1]?.data?.[week]) || 0,
    // }));
    const weeklyOrData = data[0]?.data || {};
    const agileOrData = data[1]?.data || {};

    // get all unique weeks from both sources
    const allWeeks = Array.from(new Set([
        ...Object.keys(weeklyOrData),
        ...Object.keys(agileOrData),
    ])).sort((a, b) => {
        const numA = parseInt(a.replace("Week ", ""), 10);
        const numB = parseInt(b.replace("Week ", ""), 10);
        return numA - numB;
    });

    const transformedData = allWeeks.map((week) => ({
        weekLabel: week,
        weeklyOr: weeklyOrData[week] ? parseFloat(weeklyOrData[week]) : null,
        agileOr: agileOrData[week] ? parseFloat(agileOrData[week]) : null,
    }));

    const CustomLegend = (props) => {
        const { payload } = props;
        return (
            <div style={{ display: 'flex', justifyContent: 'left', padding: '10px' }}>
                {payload.map((entry, index) => {
                    const { value, color } = entry;
                    return (
                        <span
                            key={`item-${index}`}
                            style={{
                                display: 'flex',
                                alignItems: 'center',
                                gap: '4px',
                                padding: '0 10px',
                            }}
                        >
                            <span
                                style={{
                                    backgroundColor: color,
                                    width: '6px',
                                    height: '12px',
                                    display: 'inline-block',
                                    borderRadius: '2px',
                                }}
                            />
                            <span style={{ color: '#4D4D4F' }}>{value}</span>
                        </span>
                    );
                })}
            </div>
        );
    };

    const legendStyle = {
        fontSize: '10px',
        paddingTop: '15px',
        color: '#4D4D4F',
    };

    const CustomTooltip = ({ active, payload }) => {
        if (active && payload && payload.length) {
            return (
                <div className={styles.customTooltip}>
                    {payload.map((item, index) => (
                        <p key={index} className={styles.tooltipItem}>
                            <span style={{ fontWeight: 600 }}>{item.name}</span>&nbsp; : &nbsp;
                            {item.name.includes('Agile OR') ? `${item.value}%` : ""}
                            {item.name.includes('Weekly OR') ? `${item.value}%` : ""}
                        </p>
                    ))}
                </div>
            );
        }
        return null;
    };

    const formatYAxisTick = (value) => {
        return `${value}%`;
    };
    return (
        <>
            <ResponsiveContainer width="100%" height={220}>
                <ComposedChart data={transformedData}
                    margin={{
                        top: 10,
                        right: 0,
                        bottom: 10,
                        left: 0,
                    }} >
                    <CartesianGrid strokeDasharray="3 3" vertical={false} horizontal={true} />
                    <XAxis
                        dataKey="weekLabel"
                        tickLine={false}
                        axisLine={false}
                        className={styles.BarLabel}
                    >
                        <Label value="Past 12 weeks" offset={10} position="bottom" className={styles.labelListOR} />
                    </XAxis>
                    <YAxis domain={[0, 'auto']} tickLine={false} axisLine={false} className={styles.BarLabel} padding={{ left: 0, right: 0 }} tickFormatter={formatYAxisTick}
                    >
                        <Label value="OR (percentage)" angle={-90} offset={15} position="insideLeft" style={{ textAnchor: "middle" }} className={styles.labelListOR} />
                    </YAxis>
                    <Tooltip
                        content={<CustomTooltip />}
                        wrapperStyle={{
                            fontSize: '12px',
                            padding: '6px',
                        }}
                    />
                    <Legend verticalAlign="bottom" align="left" wrapperStyle={legendStyle} content={<CustomLegend />} />
                    <Line type="monotone" dataKey="weeklyOr" name="Weekly OR" stroke="#005EEF" fill="#005EEF" strokeWidth={1} connectNulls={false} />
                    <Line type="monotone" dataKey="agileOr" name="Overall Agile OR" stroke="#FFC000" fill="#FFC000" strokeWidth={1} connectNulls={false} />
                </ComposedChart>
            </ResponsiveContainer>
        </>
    );
};

export default LineGraphOR;

